/* Matrascheck slide-in: toont na 15% gelezen of 10 s, max 1x per bezoek, 1 dag weg na sluiten. */
(function(){
  var el=document.getElementById('mcs'); if(!el) return;
  var SLEUTEL='mcs_gesloten_tot', DAGEN=1, SCROLL=0.15, SEC=10;
  function gesloten(){try{return Date.now()<+localStorage.getItem(SLEUTEL)}catch(e){return false}}
  function dl(ev,x){window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:ev,matrascheck_plek:el.getAttribute('data-plek')},x||{}))}
  var tpl=document.getElementById('mcs-meting');
  el.querySelectorAll('[data-mcs-svg]').forEach(function(s){s.replaceWith(tpl.content.cloneNode(true))});
  var teller=el.querySelector('[data-mcs-teller]'), getoond=false, lus;
  function meet(){
    el.classList.remove('is-meet'); void el.offsetWidth; el.classList.add('is-meet');
    teller.textContent='0'; var t0=null;
    setTimeout(function(){requestAnimationFrame(function stap(t){if(!t0)t0=t;var p=Math.min(1,(t-t0)/900);teller.textContent=Math.round(90*(1-Math.pow(1-p,3)));if(p<1)requestAnimationFrame(stap)})},1500);
  }
  function toon(bron){
    if(getoond||gesloten()) return;
    // wacht tot de bezoeker een cookiekeuze heeft gemaakt (banner dicht)
    var cb=document.getElementById('CybotCookiebotDialog'), zichtbaar=cb&&cb.getClientRects().length>0&&getComputedStyle(cb).visibility!=='hidden';
    if((window.Cookiebot&&Cookiebot.hasResponse===false)||zichtbaar){setTimeout(function(){toon(bron)},1000);return}
    getoond=true;
    el.hidden=false; requestAnimationFrame(function(){requestAnimationFrame(function(){el.classList.add('is-open')})});
    setTimeout(meet,450); lus=setInterval(meet,7000);
    dl('matrascheck_slidein_view',{matrascheck_trigger:bron});
  }
  function sluit(){
    el.classList.add('is-dicht'); el.classList.remove('is-groot'); clearInterval(lus);
    try{localStorage.setItem(SLEUTEL,Date.now()+DAGEN*864e5)}catch(e){}
    dl('matrascheck_slidein_sluit');
  }
  // trigger: 15% van het artikel gelezen of 10 seconden op de pagina, wat het eerst komt
  var body=document.querySelector('[data-artikel-body]')||document.body;
  function scrolCheck(){var r=body.getBoundingClientRect();var gelezen=(innerHeight-r.top)/Math.max(1,r.height);if(gelezen>=SCROLL){toon('scroll');removeEventListener('scroll',scrolCheck)}}
  addEventListener('scroll',scrolCheck,{passive:true});
  setTimeout(function(){toon('tijd')},SEC*1000);
  el.querySelectorAll('[data-mcs-sluit]').forEach(function(b){b.addEventListener('click',function(e){e.stopPropagation();sluit()})});
  el.querySelector('[data-mcs-groot]').addEventListener('click',function(){el.classList.add('is-groot');this.setAttribute('aria-expanded','true');meet();dl('matrascheck_slidein_open')});
  el.addEventListener('click',function(e){if(el.classList.contains('is-groot')&&e.target===el)sluit()});
  el.querySelector('[data-mcs-cta]').addEventListener('click',function(){dl('matrascheck_cta')});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&el.classList.contains('is-open'))sluit()});
})();
